module.exports = __webpack_public_path__ + "static/Print pattern XS-03_colorbase_3000-01-2a86d274b880c00705ba7a63f9c17edc.png";